import React from 'react';
import SvgIcon24 from '../svgIcon24';

/* eslint-disable max-len */
/* eslint-disable react/self-closing-comp */

const ChevronLeftIcon = ({ ...others }) => (
  <SvgIcon24
    title="icons / nav24 / chevron left"
    {...others}
  >
    <path d="M12.5785173,12.0211459 L7.32684676,17.2728165 C6.89000935,17.7096539 6.89128668,18.4184991 7.32927694,18.8564894 L8.18580253,19.713015 C8.62367488,20.1508873 9.33282729,20.1520932 9.7694754,19.7154451 L16.6731532,12.8117673 C16.891168,12.5937525 17.0000588,12.3079872 17,12.0219532 C16.999935,11.7342401 16.8910737,11.4484451 16.6731532,11.2305246 L9.7694754,4.32684676 C9.33263799,3.89000935 8.62379279,3.89128668 8.18580253,4.32927694 L7.32927694,5.18580253 C6.89140459,5.62367488 6.89019865,6.33282729 7.32684676,6.7694754 L12.5785173,12.0211459 Z" id="Combined-Shape" transform="translate(12.000000, 12.021088) rotate(-180.000000) translate(-12.000000, -12.021088) "></path>
  </SvgIcon24>
);

export default ChevronLeftIcon;
